import * as React from "react";
import { PillFilterProps } from "components/flexComponents/Packages/typings";
import { useLocalization } from "@shared-ui/localization-context";
import { withStores } from "stores";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkPill } from "uitk-react-pill";
import { PillOption } from "components/flexComponents/Packages/config";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";

export const PillFilter = withStores(
  "packagePillStore",
  "analytics"
)((props: PillFilterProps) => {
  const { formatText } = useLocalization();

  const { analytics, pillId, packagePillStore, pillOptions, fetchPackages } = props;

  const [isOpen, setIsOpen] = React.useState(false);
  const toggleIsOpen = () => setIsOpen(!isOpen);

  const handleItemClick = (pillOption: PillOption) => () => {
    toggleIsOpen();
    fetchPackages(pillId, pillOption);
    packagePillStore.updatePill(pillId, localizedPillDisplayValue(pillOption));

    const trackingInfo: FlexTrackingInfo = {
      moduleName: "packages",
      rfrr: `pill.${pillId}.${pillOption.lptParamValue}`,
      action: Action.CLICK,
    };
    sendDelayedTrackEvent(trackingInfo, analytics);
  };

  const localizedPillDisplayValue = ({ locKey, locArg }: PillOption): string => {
    return locArg ? formatText(`${locKey}`, locArg) : formatText(`${locKey}`);
  };

  return (
    <UitkMenu className="all-t-padding-two" isOpen={isOpen} onTriggerClick={toggleIsOpen} id={pillId}>
      <UitkMenuTrigger>
        <UitkPill id={`pill-${pillId}`} triggerPill={true} toggleState={packagePillStore.getPillToggleState(pillId)}>
          <span data-testid="pillName">{packagePillStore.getPillName(pillId)}</span>
        </UitkPill>
      </UitkMenuTrigger>
      <UitkMenuContainer position={PositionType.LEFT} width={165}>
        {pillOptions.map((option, index) => (
          <p
            key={index}
            className="all-x-margin-three"
            onClick={handleItemClick(option)}
            data-testid={`pill-${pillId}-options`}
          >
            {localizedPillDisplayValue(option)}
          </p>
        ))}
      </UitkMenuContainer>
    </UitkMenu>
  );
});
